export const text = "#363231";
export const hover = "#FB5400";
export const hardGray = "#A7A19F";
export const softWhite = "#F8F6F5";
export const white = "#FFFFFF";
export const softGray = "#E7E8E8";
export const Transition = "cubic-bezier(0.4, 0, 0, 1)";
